import { AutoComplete, Input, Select } from 'antd';
import {
	makeValueSpec,
	readValueSpec,
} from 'src/_shared/services/job-sync/serde';

// The generic result control for a rule set: a `ValueSpec` is one of
//   value (literal) | field (copyFrom) | template ('${field}')
// A small kind Select picks the shape; the value control follows. Literal values keep their type until
// the user edits them; field/template are strings.
const KIND_OPTIONS = [
	{ value: 'literal', label: 'value' },
	{ value: 'copyFrom', label: 'field' },
	{ value: 'template', label: 'template' },
];

export default function ValueSpecEditor({ spec, onChange, fieldOptions = [] }) {
	const { kind, value } = readValueSpec(spec);

	const handleKind = (nextKind) => {
		let v = value;
		if (nextKind !== 'literal') v = value == null ? '' : String(value);
		onChange(makeValueSpec(nextKind, v));
	};

	return (
		<div style={{ display: 'flex', gap: 6, alignItems: 'center', width: '100%', minWidth: 0 }}>
			<Select
				value={kind}
				onChange={handleKind}
				options={KIND_OPTIONS}
				style={{ width: 96, flex: 'none' }}
				dropdownMatchSelectWidth={false}
			/>
			{kind === 'copyFrom' ? (
				<AutoComplete
					value={value == null ? '' : String(value)}
					options={fieldOptions.map((f) => ({ value: f }))}
					filterOption={(input, option) =>
						String(option.value).toLowerCase().includes(input.toLowerCase())
					}
					onChange={(v) => onChange(makeValueSpec('copyFrom', v))}
					placeholder="field"
					style={{ width: '100%' }}
				/>
			) : (
				<Input
					value={value == null ? '' : String(value)}
					onChange={(e) => onChange(makeValueSpec(kind, e.target.value))}
					placeholder={kind === 'template' ? '${field}' : 'value'}
				/>
			)}
		</div>
	);
}
